<template>
  <div v-if="pageData" class="grid lg:grid-flow-col lg:auto-cols-fr">
    <FeaturedCardLinkComponent
      v-if="pageData[0]"
      :title="locale === 'en' ? pageData[0]?.titleEn : pageData[0]?.titleTh"
      :link="pageData[0].primaryButtonHref || '#'"
      :button-text="
        locale === 'en'
          ? pageData[0]?.primaryButtonEn
          : pageData[0]?.primaryButtonTh || pageData[0]?.primaryButtonEn
      "
      :image-url="pageData[0].imageUrl"
    />
    <FeaturedCardLinkComponent
      v-if="pageData[1]"
      :title="locale === 'en' ? pageData[1]?.titleEn : pageData[1]?.titleTh"
      :link="pageData[1].primaryButtonHref || '#'"
      :button-text="
        locale === 'en'
          ? pageData[1]?.primaryButtonEn
          : pageData[1]?.primaryButtonTh || pageData[1]?.primaryButtonEn
      "
      :image-url="pageData[1].imageUrl"
    />
  </div>
</template>

<script setup lang="ts">
import { cmsRepository } from '~/repository/cmsRepository'

const FeaturedCardLinkComponent = defineAsyncComponent({
  loader: () => import('../components/FeaturedCardLink.vue')
})

const { locale } = useI18n()

const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)

const { data: pageData } = await useAsyncData<
  {
    imageUrl: string
    mobileImageUrl?: string
    titleEn: string
    titleTh: string
    primaryButtonEn: string
    primaryButtonTh?: string
    primaryButtonHref?: string
  }[]
>(
  'getLandingPageFeatured',
  async () => {
    const response = await cmsRepo.getWidget('landing-page-featured')
    if (response.data.data.items) return response.data.data.items
    return null
  },
  { server: false }
)
</script>
